define('model/disclosure.assignment.detail.model',['require','exports','module','underscore','fukit','model/user.model'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      BaseModel = require('fukit').BaseModel,
      UserModel = require('model/user.model');

  var DisclosureAssignmentDetailModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureAssignmentDetailModel': '@constructor',
    },

    defaults: function() {
      return {
        reviewer: null,
      };
    },

    childModels: {
      reviewer: UserModel,
    },

    urlRoot: '/api/v1/compliance/disclosureAssignmentDetail',

    clearReviewer: function(model) {
      if (!_.isUndefined(model.get('previousDisclosureReviewer'))) {
        model.set({
          disclosureReviewer: model.get('previousDisclosureReviewer'),
        });
        model.unset('previousDisclosureReviewer');
      }
    },
  });

  module.exports = DisclosureAssignmentDetailModel;
});

